import { requestGlobalUserData } from "../../apis";

export const apiGetUserInfo = (params) =>
  requestGlobalUserData("get", `/user/info`, params, true, false);

export const apiLogout = (params) =>
  requestGlobalUserData("post", `/user/logout`, params, true, false);
